const _separateThousands = (numberString: string) => {
  const withTrailingZeros = numberString.replaceAll(/\d(?=(\d{3})+\.)/g, '$& ')
  return withTrailingZeros.replace(/\.00$/, '')
}

const getDecimalLength = (number: number, fractionDigitsLength?: number) => {
  const numberString = String(number)
  const numberWithoutSpaces = numberString.replaceAll(/\s/g, '')
  const [, decimal = ''] = numberWithoutSpaces.split('.')
  return decimal.length > 2 ? fractionDigitsLength || 2 : decimal.length
}

export const separateThousands = (number: number) => {
  return number
    ? _separateThousands(number.toFixed(getDecimalLength(number)))
    : '0'
}

export const formatNumberLocale = (input: string | number) => {
  const locale = navigator.language
  const numberString = String(input)
  const numberWithoutSpaces = numberString.replaceAll(/\s/g, '')
  const number = Number(numberWithoutSpaces)

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: getDecimalLength(number, 3),
    maximumFractionDigits: getDecimalLength(number, 3)
  }).format(number)
}

export const formatRuble = (number?: number) => {
  return `${formatNumberLocale(separateThousands(number || 0))} ₽`
}

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (phoneNumber) {
    return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(
      2,
      5
    )} ${phoneNumber.slice(5, 8)} ${phoneNumber.slice(
      8,
      10
    )} ${phoneNumber.slice(10)}`
  }
}

export const normalizeNumber = (value?: string, decimalSeparator = ',') => {
  if (typeof value !== 'string') {
    value = String(value)
  }

  const parts = value.split(decimalSeparator)
  const integerPart = parts[0].replaceAll(/\D/g, '')
  const decimalPart = parts[1]?.replaceAll(/\D/g, '')

  const normalized =
    decimalPart === undefined ? integerPart : `${integerPart}.${decimalPart}`
  return normalized
}

export const makePhoneCallable = (phoneNumber?: string) =>
  phoneNumber?.replaceAll(' ', '') || ''
